var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2638_1617)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9787 9C11.352 9 8.25483 11.2558 7 14.44C8.25483 17.6242 11.352 19.88 14.9787 19.88C18.6053 19.88 21.7025 17.6242 22.9573 14.44C21.7025 11.2558 18.6053 9 14.9787 9ZM14.9787 18.0667C12.9767 18.0667 11.352 16.4419 11.352 14.44C11.352 12.4381 12.9767 10.8133 14.9787 10.8133C16.9806 10.8133 18.6053 12.4381 18.6053 14.44C18.6053 16.4419 16.9806 18.0667 14.9787 18.0667ZM14.9787 12.264C13.7746 12.264 12.8027 13.2359 12.8027 14.44C12.8027 15.6441 13.7746 16.616 14.9787 16.616C16.1827 16.616 17.1547 15.6441 17.1547 14.44C17.1547 13.2359 16.1827 12.264 14.9787 12.264Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2638_1617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c6ce671d7d0f76d2d2b64e233e497f2a.svg";
export { ForwardRef as ReactComponent };